export default "__VITE_ASSET__CQ9xRCgz__"